export const OTHERPRODUCTS = [
  {
    name: "Instant Settlements",
    url: "/instant-settlements/",
  },
];

export const INTEGRATIONS = [
  {
    name: "Shopify",
    url: "/shopify-payment-gateway-india/",
  },
  {
    name: "Wix",
    url: "/wix-payment-gateway/",
  },
  {
    name: "Woocommerce",
    url: "/woocommerce-payment-gateway-india/",
  },
  {
    name: "Paypal",
    url:
      "https://docs.cashfree.com/docs/activate-payment-methods#activate-paypal-for-your-account",
  },
  {
    name: "Wordpress",
    url: "https://docs.cashfree.com/docs/wordpress",
  },
  {
    name: "Zoho",
    url: "https://docs.cashfree.com/docs/zoho",
  },
];

export const CERTIFICATES = [
  {
    name: "RBI Authorised Payment Aggregator",
    certificateLabel: "Certificate of Authorisation No. 160/2023",
    certificateLink: "CoA-CashfreePaymentsIndiaPrivateLimited",
  },
  {
    name:
      "RBI Authorised Export & Import Payment Aggregator - Cross Border (PA-CB - E&I)",
    certificateLabel: "Certificate of Authorisation No. S408/02.27.004/2024-25",
    certificateLink: "CBLicense",
  },
  {
    name: "RBI Authorised Prepaid Payment Instrument (PPI) Provider",
    certificateLabel: "Certificate of Authorisation No. 209/2024",
    certificateLink: "CoA-CashfreePaymentsIndiaPrivateLimited-PPI",
  },
];
